module.exports = __webpack_public_path__ + "static/img/tab3.5ca1431.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/tab3.jpg
// module id = /RbB
// module chunks = 1